<template>
    <!-- <v-container fluid class="pa-1" :style="$vuetify.display.mobile ? 'width: 100vw;' : ''"> -->
    <v-row no-gutters class="pt-4 pl-4">
        <v-col :cols="12 - rightColumnSize" class="pr-2">
            <v-card class="elevation-0 fill-height rounded-b-0">
                <DocumentMenu
                    :MenuOptions="documentMenuOptions"
                    @back="back()"
                    @zoom-in="isPDF ? zoomInPdf() : zoomManager.zoomIn()"
                    @reset-zoom="isPDF ? resetZoomPdf() : zoomManager.resetZoom()"
                    @zoom-out="isPDF ? zoomOutPdf() : zoomManager.zoomOut()"
                    @rotate-left="
                        documentPdfRotation = rotate('left', zoomManager, documentPdfRotation)
                    "
                    @rotate-right="
                        documentPdfRotation = rotate('right', zoomManager, documentPdfRotation)
                    "
                    @edit="openAccountingItemEditionDialog()"
                    @display-file="
                        showAccountingLines = false;
                        displayActivity = false;
                    "
                    @display-accounting-line="
                        showAccountingLines = true;
                        displayActivity = false;
                    "
                    @download="startDownloadFile()"
                    @upload="dialogUploadDocument = true"
                    @activity="displayActivity = true"
                    @delete="deleteDocumentDialog = true"
                ></DocumentMenu>
                <!--
                <v-row no-gutters class="pa-2">
                    <v-col cols="6">
                        <v-btn-back
                            @click.stop="back()"
                            v-if="mode !== 'GeneralLedger' && goBackHistory"
                            data-cy="document-back"
                        />
                        <template v-if="!isPDF && zoomManager && !showAccountingLines">
                            <v-btn-icon
                                icon="$oss-zoom-out"
                                :disabled="zoomManager.disableZoomOut()"
                                @click.stop="zoomManager.zoomOut()"
                            />
                            <v-btn-icon
                                icon="$oss-focus"
                                :disabled="zoomManager.disableResetZoom()"
                                @click.stop="zoomManager.resetZoom()"
                            />
                            <v-btn-icon
                                icon="$oss-zoom-in"
                                :disabled="zoomManager.disableZoomIn()"
                                @click.stop="zoomManager.zoomIn()"
                            />

                            <v-btn-icon
                                class="my-0 mr-1"
                                @click.stop="
                                    documentPdfRotation = rotate(
                                        'left',
                                        zoomManager,
                                        documentPdfRotation,
                                    )
                                "
                                icon="$fa-undo"
                            >
                            </v-btn-icon>
                            <v-btn-icon
                                class="my-0"
                                @click.stop="
                                    documentPdfRotation = rotate(
                                        'right',
                                        zoomManager,
                                        documentPdfRotation,
                                    )
                                "
                                icon="$fa-redo"
                            ></v-btn-icon>
                        </template>
                        <template v-if="isPDF && !showAccountingLines">
                            <v-btn-icon icon="$oss-zoom-out" @click.stop="zoomOutPdf" />
                            <v-btn-icon icon="$oss-focus" @click.stop="resetZoomPdf()" />
                            <v-btn-icon icon="$oss-zoom-in" @click.stop="zoomInPdf" />

                            <v-btn-icon
                                class="my-0 mr-1"
                                @click.stop="
                                    documentPdfRotation = rotate(
                                        'left',
                                        zoomManager,
                                        documentPdfRotation,
                                    )
                                "
                                icon="$fa-undo"
                            >
                            </v-btn-icon>
                            <v-btn-icon
                                class="my-0"
                                @click.stop="
                                    documentPdfRotation = rotate(
                                        'right',
                                        zoomManager,
                                        documentPdfRotation,
                                    )
                                "
                                icon="$fa-redo"
                            ></v-btn-icon>
                        </template>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end">
                        <!-- ** AccountingItemEdition -->
                <!--
                        <v-tooltip
                            v-if="editionMessage && editionMessage.length"
                            class="pt-4 px-4"
                            location="bottom"
                        >
                            <template v-slot:activator="{ props }">
                                <div style="height: fit-content" v-bind="props">
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        class="mx-1"
                                        @click="openAccountingItemEditionDialog()"
                                        :disabled="disabledAccountingEdition"
                                        v-if="showAccountingLines && displayAIEditionDialog"
                                        v-bind="props"
                                    />
                                </div>
                            </template>

                            <div v-html="editionMessage" />
                        </v-tooltip>

                        <template v-else>
                            <v-btn-icon
                                icon="$oss-edit"
                                @click="openAccountingItemEditionDialog()"
                                :disabled="disabledAccountingEdition"
                                v-if="showAccountingLines && displayAIEditionDialog"
                            />
                        </template>
                        <v-btn-toggle
                            v-if="(isPDF || document.signedUrl) && displayAIStaticFull"
                            v-model="showAccountingLines"
                            rounded="xl"
                            class="mt-1"
                            density="compact"
                            divided
                            variant="outlined"
                            color="secondary"
                        >
                            <v-btn
                                icon="$oss-file"
                                :value="true"
                                @click="
                                    showAccountingLines = false;
                                    displayActivity = false;
                                "
                            />
                            <v-btn
                                icon="$oss-accounting-lines"
                                :value="false"
                                @click="
                                    showAccountingLines = true;
                                    displayActivity = false;
                                "
                            />
                        </v-btn-toggle>
                        <v-btn-icon
                            icon="$oss-file"
                            v-else-if="(isPDF || document.signedUrl) && displayActivity"
                            size="small"
                            @click="displayActivity = false"
                        ></v-btn-icon>
                        <v-menu offset-y>
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    icon="$dots_vertical"
                                    v-bind="props"
                                    color="secondary"
                                />
                            </template>
                            <v-list nav rounded="xl">
                                <v-list-item @click="startDownloadFile" v-if="document.signedUrl">
                                    <v-list-item-title>Télécharger le document</v-list-item-title>
                                    <template #append>
                                        <v-icon>$oss-download</v-icon>
                                    </template>
                                </v-list-item>
                                <v-list-item @click="dialogUploadDocument = true" v-else>
                                    <v-list-item-title>Ajouter un document</v-list-item-title>
                                    <template #append>
                                        <v-icon>$oss-upload</v-icon>
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    @click="displayActivity = true"
                                    v-if="isAccountingUser"
                                >
                                    <v-list-item-title>Afficher l'activité</v-list-item-title>
                                    <template #append>
                                        <v-icon>$oss-activity</v-icon>
                                    </template>
                                </v-list-item>
                                <v-divider class="mb-2" />

                                <v-tooltip
                                    v-if="
                                        editionMessage &&
                                        editionMessage.length &&
                                        orphelinDepreciationAcrId &&
                                        orphelinDepreciationAcrId.length
                                    "
                                    location="bottom"
                                >
                                    <template v-slot:activator="{ props }">
                                        <div style="height: fit-content" v-bind="props">
                                            <v-list-item
                                                @click="deleteOrphelinDocumentDialog = true"
                                                :disabled="disabledDelete"
                                                color="error"
                                                :active="!disabledDelete"
                                            >
                                                <v-list-item-title>Supprimer</v-list-item-title>
                                                <template #append>
                                                    <v-icon size="small">$oss-trash</v-icon>
                                                </template>
                                            </v-list-item>
                                        </div>
                                    </template>
                                    <div v-html="editionMessage" />
                                </v-tooltip>

                                <v-tooltip
                                    v-else-if="editionMessage && editionMessage.length"
                                    location="bottom"
                                >
                                    <template v-slot:activator="{ props }">
                                        <div style="height: fit-content" v-bind="props">
                                            <v-list-item
                                                @click="deleteDocumentDialog = true"
                                                :disabled="disabledDelete"
                                                color="error"
                                                :active="!disabledDelete"
                                            >
                                                <v-list-item-title>Supprimer</v-list-item-title>
                                                <template v-slot:append>
                                                    <v-icon size="small">$oss-trash</v-icon>
                                                </template>
                                            </v-list-item>
                                        </div>
                                    </template>

                                    <div v-html="editionMessage" />
                                </v-tooltip>

                                <v-list-item
                                    v-else
                                    @click="deleteDocumentDialog = true"
                                    :disabled="disabledDelete"
                                    color="error"
                                    :active="!disabledDelete"
                                >
                                    <v-list-item-title>Supprimer</v-list-item-title>
                                    <template #append>
                                        <v-icon size="small">$oss-trash</v-icon>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                </v-row> -->
                <v-row no-gutters>
                    <template v-if="showAccountingLines && !displayActivity && displayAIStaticFull">
                        <v-col cols="12" style="height: calc(100vh - 130px); overflow-y: auto">
                            <accounting-item-static
                                :companyId="companyId"
                                :documentId="document.id"
                                :mode="isAccountingItem ? 'AllOption' : 'Embedded'"
                                ref="accountingItemStatic"
                                :key="accountingLinesRefreshKey"
                                @upsert="onAccountingItemUpdated"
                                v-if="document.id"
                            />
                        </v-col>
                    </template>
                    <template v-else-if="displayActivity">
                        <v-col cols="12" style="height: calc(100vh - 130px); overflow-y: auto">
                            <UsersActivitiesHistory :documentId="document.id">
                            </UsersActivitiesHistory>
                        </v-col>
                    </template>
                    <template v-else>
                        <v-col
                            cols="12"
                            class="d-flex justify-center"
                            v-if="isPDF"
                            style="height: calc(100vh - 130px); overflow-y: auto"
                        >
                            <ossPdf
                                ref="ossPdfRef"
                                :rotation="documentPdfRotation"
                                :documentId="document.id"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            style="height: calc(100vh - 130px); overflow-y: auto"
                            v-else
                        >
                            <div
                                style="
                                    position: relative;
                                    width: 100%;
                                    height: 0;
                                    padding: 0;
                                    padding-bottom: 141.4516129032258%;
                                    margin-bottom: 50px;
                                "
                            >
                                <svg
                                    id="svg-document-static"
                                    v-if="document"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="100%"
                                    :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                    style="
                                        position: absolute;
                                        width: 100%;
                                        left: 0;
                                        top: 0;
                                        background: #fff;
                                    "
                                >
                                    <g>
                                        <image
                                            id="svg-image-document-static"
                                            :xlink:href="document.signedUrl"
                                            x="0"
                                            y="0"
                                            :height="`${imageHeight}px`"
                                            :width="`${imageWidth}px`"
                                        />
                                        <template
                                            v-for="(variant, index) in svgVariants"
                                            :key="`coord-${document.id}-${index}`"
                                        >
                                            <template
                                                v-for="(coord, index2) in variant.coordinates"
                                                :key="`coord-${document.id}-${index}-${index2}`"
                                            >
                                                <polygon
                                                    :ref="`variants-${index}-${index2}`"
                                                    :points="getPoints(coord)"
                                                    :style="
                                                        variant.active
                                                            ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                            : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                    "
                                                    @click.stop="
                                                        variant.active
                                                            ? ''
                                                            : showCorrespondingField({
                                                                  variant,
                                                                  currentIndex: index,
                                                                  copyIndex: index2,
                                                              })
                                                    "
                                                    :class="variant.focus ? 'highlighted' : ''"
                                                />
                                            </template>
                                        </template>
                                    </g>
                                </svg>
                            </div>
                        </v-col>
                    </template>
                </v-row>
            </v-card>
            <v-list v-if="associatedFields.show">
                <v-list-item
                    v-for="(field, key, index) in associatedFields.fields"
                    :key="`field-${document.id}-${key}-${index}`"
                    @click="onFieldAssociation(field, key)"
                    class="oss-list-item"
                >
                    <v-list-item-title v-text="key" />
                </v-list-item>
            </v-list>
        </v-col>
        <v-col :cols="rightColumnSize" class="pl-2">
            <v-card class="rounded-e-0 overflow-y-auto">
                <v-window v-model="windowStep" touchless class="mx-2">
                    <v-window-item :step="0">
                        <v-form ref="form" v-model="valid">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-list single-line class="pt-2 pb-0 space-y-2">
                                        <v-list-item
                                            :ripple="false"
                                            color="success"
                                            border
                                            rounded="xl"
                                        >
                                            <v-list-item-title class="body-1">
                                                <v-row no-gutters class="align-center">
                                                    <v-col
                                                        cols="3"
                                                        style="border-right: 1px #ededed solid"
                                                    >
                                                        <b>Statut</b>
                                                    </v-col>
                                                    <v-col
                                                        cols="9"
                                                        class="pl-2 d-flex justify-space-between align-center"
                                                    >
                                                        {{ documentStatus }}
                                                        <v-menu
                                                            offset-y
                                                            v-if="
                                                                displayAccountingItemEditionEmbedded
                                                            "
                                                        >
                                                            <template v-slot:activator="{ props }">
                                                                <v-btn-icon
                                                                    icon="$dots_vertical"
                                                                    v-bind="props"
                                                                    size="small"
                                                                    class="mx-1"
                                                                    color="secondary"
                                                                />
                                                            </template>
                                                            <v-list>
                                                                <v-list-item
                                                                    @click="
                                                                        accountingItemEditionEmbeddedFullMode =
                                                                            !accountingItemEditionEmbeddedFullMode
                                                                    "
                                                                >
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-2"
                                                                            >$oss-eye</v-icon
                                                                        >
                                                                        {{
                                                                            accountingItemEditionEmbeddedFullMode
                                                                                ? "Cacher les détails de chaque ligne"
                                                                                : "Afficher les détails de chaque ligne"
                                                                        }}
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            :ripple="false"
                                            color="success"
                                            border
                                            rounded="xl"
                                            v-if="
                                                (isEditable &&
                                                    currentUser.profile.configuration.document
                                                        .write) ||
                                                showRestoreDocumentBtn
                                            "
                                        >
                                            <v-list-item-title class="body-1">
                                                <v-row no-gutters class="align-center">
                                                    <v-col
                                                        cols="3"
                                                        style="border-right: 1px #ededed solid"
                                                    >
                                                        <b>Actions</b>
                                                    </v-col>
                                                    <v-col
                                                        cols="9"
                                                        class="d-flex justify-end align-center"
                                                    >
                                                        <v-tooltip
                                                            v-if="
                                                                canBeRestoredTooltipMessages?.length
                                                            "
                                                            class="pt-4 px-4"
                                                            location="bottom"
                                                        >
                                                            <template v-slot:activator="{ props }">
                                                                <div
                                                                    style="height: fit-content"
                                                                    v-bind="props"
                                                                >
                                                                    <v-btn
                                                                        rounded
                                                                        elevation="0"
                                                                        disabled
                                                                        size="small"
                                                                    >
                                                                        Restaurer
                                                                        <v-icon
                                                                            size="small"
                                                                            location="end"
                                                                        >
                                                                            $oss-edit
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>

                                                            <template
                                                                v-for="line of canBeRestoredTooltipMessages"
                                                            >
                                                                <h4>
                                                                    {{ line }}
                                                                </h4>
                                                            </template>
                                                        </v-tooltip>

                                                        <template v-else>
                                                            <v-btn
                                                                v-if="showRestoreDocumentBtn"
                                                                rounded
                                                                elevation="0"
                                                                @click="restoreDialog = true"
                                                                size="small"
                                                            >
                                                                Restaurer
                                                                <v-icon size="small" location="end">
                                                                    $oss-edit
                                                                </v-icon>
                                                            </v-btn>

                                                            <v-btn
                                                                v-else-if="
                                                                    isEditable &&
                                                                    currentUser.profile
                                                                        .configuration.document
                                                                        .write
                                                                "
                                                                rounded
                                                                elevation="0"
                                                                @click="editDialog = true"
                                                                data-cy="DocumentStatic-edit"
                                                                size="small"
                                                            >
                                                                Modifier
                                                                <v-icon size="small" location="end">
                                                                    $oss-edit
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            :ripple="false"
                                            border
                                            rounded="xl"
                                            v-if="!isAccountingItem"
                                        >
                                            <v-list-item-title class="body-1">
                                                <v-row no-gutters class="align-center">
                                                    <v-col
                                                        cols="3"
                                                        style="border-right: 1px #ededed solid"
                                                    >
                                                        <b>{{ thirdPartyType() }}</b>
                                                    </v-col>
                                                    <v-col cols="9" class="pl-2">
                                                        <div>
                                                            {{
                                                                document.thirdPartyCompany
                                                                    ? document.thirdPartyCompany
                                                                          .name
                                                                    : ""
                                                            }}
                                                        </div>
                                                        <div class="body-2 pt-1">
                                                            Siret :
                                                            {{
                                                                document.thirdPartyCompany &&
                                                                document.thirdPartyCompany.siret
                                                                    ? getSiretValue(
                                                                          document.thirdPartyCompany
                                                                              .siret,
                                                                      )
                                                                    : ""
                                                            }}
                                                        </div>
                                                        <div class="body-2">
                                                            Adresse : {{ fullAddress }}
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                    <v-row
                                        no-gutters
                                        v-if="
                                            activateTagguing &&
                                            document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                        "
                                    >
                                        <v-col cols="12">
                                            <FreeTag
                                                :companyTags="allCompanyTags"
                                                :document="inDocument"
                                                :splitUserPartitions="true"
                                                @onTagsChanged="startToBeDoneIfNecessary"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <v-divider />
                                </v-col>
                                <v-col
                                    cols="12"
                                    v-if="!displayAccountingItemEditionEmbedded"
                                    class="mt-2"
                                >
                                    <v-text-field-filled
                                        v-model="document.displayName"
                                        outlined
                                        label="Nom du document"
                                        hide-details
                                        density="compact"
                                    />
                                </v-col>
                                <v-col
                                    cols="12"
                                    v-if="
                                        isAccountingUser &&
                                        currentUser.profile.configuration.accounting.write &&
                                        currentUser.profile.configuration.document.write &&
                                        !multiAccountableAccount &&
                                        !isAccountingItem
                                    "
                                >
                                    <template v-if="subNetAmounts.length <= 1">
                                        <v-row
                                            no-gutters
                                            class="pt-2 flex-grow-1 flex-shrink-0"
                                            v-if="
                                                !document.multiVat &&
                                                document.type !== 'BANK_CHARGE' &&
                                                document.type !== 'WITHOUT_INVOICE'
                                            "
                                        >
                                            <v-col>
                                                <AccountableAccountVue
                                                    :companyId="companyId"
                                                    :document="document"
                                                    :inputStyle="'padding: 0px; margin: 0px;'"
                                                    :showSuggestion="false"
                                                    :showDescription="true"
                                                    :showValidation="false"
                                                    :mandatory="false"
                                                    :hideDetails="true"
                                                    :disabled="documentIsInAccountingClosing"
                                                    @close="closeAccountableAccount"
                                                    @select-accountableAccount="
                                                        selectAccountableAccount
                                                    "
                                                />
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <v-card
                                        v-else
                                        class="mx-auto"
                                        style="background: #fff !important; box-shadow: none"
                                    >
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <v-chip-group>
                                                    <v-chip
                                                        label
                                                        v-for="(item, index) in subNetAmounts"
                                                        :key="index"
                                                        size="small"
                                                        variant="outlined"
                                                    >
                                                        {{ item.accountableAccount.name }}
                                                        ({{
                                                            newCommonFormatCurrency(
                                                                item.netAmountSigned,
                                                            )
                                                        }})
                                                    </v-chip>
                                                </v-chip-group>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                                <v-col cols="12">
                                    <v-list single-line class="py-0" density="compact">
                                        <v-list-item
                                            :ripple="false"
                                            class="my-2"
                                            v-if="!displayAccountingItemEditionEmbedded"
                                            border
                                            rounded="xl"
                                        >
                                            <v-list-item-title class="body-1">
                                                <v-row no-gutters class="align-center">
                                                    <v-col
                                                        cols="3"
                                                        style="
                                                            border-right: 1px #ededed solid;
                                                            height: 28px;
                                                        "
                                                        class="d-flex align-center"
                                                    >
                                                        <b>Type</b>
                                                    </v-col>
                                                    <v-col cols="9" class="pl-2">
                                                        {{ formatCategory(document.type) }}
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            :ripple="false"
                                            class="my-2"
                                            v-if="
                                                document.invoiceNumber &&
                                                !displayAccountingItemEditionEmbedded
                                            "
                                            border
                                            rounded="xl"
                                        >
                                            <v-list-item-title class="body-1">
                                                <v-row no-gutters class="align-center">
                                                    <v-col
                                                        cols="3"
                                                        style="
                                                            border-right: 1px #ededed solid;
                                                            height: 28px;
                                                        "
                                                        class="d-flex align-center"
                                                    >
                                                        <b>{{ invoiceNumberTitle }}</b>
                                                    </v-col>
                                                    <v-col cols="9" class="pl-2">
                                                        {{ document.invoiceNumber }}
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            :ripple="false"
                                            class="my-2"
                                            v-if="
                                                document.date &&
                                                !displayAccountingItemEditionEmbedded
                                            "
                                            border
                                            rounded="xl"
                                        >
                                            <v-list-item-title class="body-1">
                                                <v-row no-gutters class="align-center">
                                                    <v-col
                                                        cols="3"
                                                        style="
                                                            border-right: 1px #ededed solid;
                                                            height: 28px;
                                                        "
                                                        class="d-flex align-center"
                                                    >
                                                        <b>Date</b>
                                                    </v-col>
                                                    <v-col cols="9" class="pl-2">
                                                        {{ formatDate(document.date) }}
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            :ripple="false"
                                            class="my-2"
                                            v-if="
                                                dueDateEnable &&
                                                !displayAccountingItemEditionEmbedded
                                            "
                                            border
                                            rounded="xl"
                                        >
                                            <v-list-item-title>
                                                <v-row no-gutters class="flex-nowrap">
                                                    <v-col
                                                        cols="4"
                                                        class="flex-grow-0 flex-shrink-1 d-flex align-center"
                                                    >
                                                        <b>{{ $t("shared.dueDate") }}</b>
                                                    </v-col>
                                                    <v-col
                                                        cols="8"
                                                        class="flex-grow-1 flex-shrink-0 pl-1"
                                                    >
                                                        <oss-date-picker-filled
                                                            :model-value="dueDate"
                                                            @change-date="onDueDateChanged"
                                                            :textFieldReadOnly="false"
                                                            :hideDetails="true"
                                                            data-cy="DocumentStatic-date"
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            :ripple="false"
                                            class="my-2"
                                            v-if="document.accountingDate"
                                            border
                                            rounded="xl"
                                        >
                                            <v-list-item-title class="body-1">
                                                <v-row no-gutters class="align-center">
                                                    <v-col
                                                        cols="3"
                                                        style="
                                                            border-right: 1px #ededed solid;
                                                            height: 28px;
                                                        "
                                                        class="d-flex align-center"
                                                    >
                                                        <b>Date comptable</b>
                                                    </v-col>
                                                    <v-col cols="9" class="pl-2">
                                                        {{ formatDate(document.accountingDate) }}
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            :ripple="false"
                                            class="my-2"
                                            v-if="document.vatType"
                                            border
                                            rounded="xl"
                                        >
                                            <v-list-item-title class="body-1">
                                                <v-row no-gutters class="align-center">
                                                    <v-col
                                                        cols="3"
                                                        style="
                                                            border-right: 1px #ededed solid;
                                                            height: 28px;
                                                        "
                                                    >
                                                        <b>Type de TVA</b>
                                                    </v-col>
                                                    <v-col cols="9" class="pl-2">
                                                        {{
                                                            $t(
                                                                `document.vatType.${document.vatType}`,
                                                            )
                                                        }}
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                            <v-row
                                no-gutters
                                class="py-2"
                                v-if="displayAccountingItemEditionEmbedded"
                            >
                                <!--- AccountingItemEditionEmbedded -->
                                <v-col cols="12">
                                    <!-- :readonly="accountingItemClosing" -->
                                    <accounting-item-edition-embedded
                                        className="accounting-item-edition-embedded"
                                        ref="accountingLinesEditionEmbedded"
                                        :companyId="companyId"
                                        :documentId="documentId"
                                        :fullMode="accountingItemEditionEmbeddedFullMode"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters v-else-if="displayStaticClient">
                                <!-- // ** details prices table -->
                                <v-col cols="12" class="d-flex align-center space-x-2">
                                    <span>Détails</span>
                                    <v-divider />
                                </v-col>
                                <v-col cols="12" class="py-2 mb-2">
                                    <accounting-item-static
                                        :companyId="companyId"
                                        :documentId="inDocument.id"
                                        @update="startToBeDoneIfNecessary"
                                        mode="Payment"
                                        @refresh="onAccountingItemUpdated"
                                        :key="accountingLinesRefreshKey"
                                    />
                                </v-col>
                            </v-row>
                            <!-- // ** AUDIT -->
                            <v-row no-gutters class="py-2 pt-3" v-if="showAudit">
                                <v-col class="d-flex align-center col-auto pr-3">
                                    Révision comptable
                                </v-col>
                                <v-col class="d-flex align-center">
                                    <v-divider />
                                </v-col>
                                <v-col
                                    v-if="
                                        tooltipDocumentAdjustmentBtn ===
                                        'Exercice comptable clôturé'
                                    "
                                    cols="auto"
                                    class="px-2"
                                >
                                    <span class="text-red">
                                        {{ tooltipDocumentAdjustmentBtn }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row v-if="showAudit">
                                <v-col>
                                    <DocumentAuditActions
                                        class="pa-0 ma-0"
                                        :companyId="companyId"
                                        :document="document"
                                        :documentId="document.id"
                                        :documentAccountingPeriod="documentAccountingPeriod"
                                        @goToWindowStep10="openWindowStep10"
                                        @goToWindowStep0="setWindowStep"
                                    />
                                    <!-- @back="windowStep = 0" -->
                                    <!-- @goToWindowStep20="openWindowStep20" -->
                                    <!-- // ** fixedAssets are not opened in window
                                        // ** they will be routed in DocumentAuditActions with openFixedAssets() -->
                                </v-col>
                            </v-row>
                            <!-- // ** STOCK OPERATIONS -->
                            <v-row no-gutters class="py-2 pt-3" v-if="enableStock">
                                <v-col class="d-flex align-center col-auto pr-3"> Stocks </v-col>
                                <v-col class="d-flex align-center">
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters v-if="enableStock">
                                <v-col cols="12" class="py-1 mb-2">
                                    <v-card
                                        class="default_card_wm mx-auto pt-2"
                                        style="
                                            background: #fff !important;
                                            border: solid rgba(0, 0, 0, 0.12) 1px;
                                            box-shadow: none;
                                        "
                                    >
                                        <v-card-title primary-title class="py-0">
                                            <v-row no-gutters>
                                                <v-col cols="auto" class="pr-2">
                                                    <span> Opérations de stock </span>
                                                </v-col>
                                                <v-spacer />
                                                <v-col cols="auto" class="d-flex justify-end">
                                                    <v-tooltip location="bottom">
                                                        <template v-slot:activator="{ props }">
                                                            <div v-bind="props">
                                                                <v-btn-edit-icon
                                                                    @click="windowStep = 11"
                                                                    size="x-small"
                                                                    variant="plain"
                                                                />
                                                            </div>
                                                        </template> </v-tooltip
                                                ></v-col>
                                            </v-row>
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-window-item>
                    <!-- // ** step="1" closeMultiAccountableAccountWindow -->
                    <!-- <v-window-item :step="1">
                        <v-card-title>
                            <v-row no-gutters class="align-center">
                                <v-col cols="1">
                                    <v-btn
                                        size="small"
                                        @click="closeMultiAccountableAccountWindow()"
                                        :loading="subNetAmountsLoading"
                                        icon="$navigate_before"
                                    >
                                    </v-btn>
                                </v-col>
                                <v-col cols="11" class="headline pl-2">
                                    Selection de plusieurs comptes comptable
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-subtitle>
                            Montant total HT: {{ newCommonFormatCurrency(netAmountSigned) }}
                        </v-card-subtitle>
                        <v-card-text>
                            <DocumentAccountableAccountsSelector
                                v-model="subNetAmounts"
                                :netAmount="netAmountSigned"
                                :companyId="companyId"
                                @modified="onSubAccountableAccountModified"
                                @cancel="closeMultiAccountableAccountWindow"
                            />
                        </v-card-text>
                    </v-window-item> -->
                    <!-- // ** DocumentAdjustments -->
                    <v-window-item :value="10">
                        <v-row no-gutters>
                            <v-col cols="12" v-if="auditChildren === 'DocumentAdjustments'">
                                <DocumentAdjustments
                                    :companyId="companyId"
                                    :thirdPartyCompany="
                                        document.thirdPartyCompany ? document.thirdPartyCompany : ''
                                    "
                                    :document="document"
                                    :documentAcrStatus="documentAcrStatus"
                                    :documentAccountingPeriod="
                                        documentAccountingPeriod || undefined
                                    "
                                    :acKey="adjustmentAcKey"
                                    @back="windowStep = 0"
                                >
                                </DocumentAdjustments>
                            </v-col>
                        </v-row>
                    </v-window-item>
                    <!-- // ** StockOperations -->
                    <v-window-item :value="11">
                        <v-row no-gutters>
                            <v-col cols="12" v-if="true">
                                <StockOperationDocumentEdition
                                    class="pa-0 ma-0"
                                    :companyId="companyId"
                                    :documentId="documentId"
                                    @back="windowStep = 0"
                                />
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>

                <v-card-actions class="d-flex justify-end space-x-1">
                    <!-- {{ displayAccountingItemEditionEmbedded }} -->
                    <v-btn
                        v-if="displayAccountingItemEditionEmbedded"
                        :disabled="disabledValidation"
                        @click="validAccountingLines()"
                        size="small"
                    >
                        Valider
                    </v-btn>
                    <v-btn-prev
                        v-if="mode !== 'GeneralLedger'"
                        :disabled="previousDisabled()"
                        @click="previous()"
                    />
                    <v-btn-next
                        v-if="mode !== 'GeneralLedger'"
                        :disabled="nextDisabled()"
                        @click="next()"
                    />
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
    <oss-dialog v-model="dialogChooseDownload" title="Télécharger le document" width="800px">
        Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté).

        <template v-slot:actions>
            <v-row no-gutters>
                <v-col cols="6" class="pr-2">
                    <v-btn-primary
                        rounded
                        block
                        @click="
                            dialogChooseDownload = false;
                            downloadFile(true);
                        "
                        size="x-large"
                        >Original</v-btn-primary
                    >
                </v-col>
                <v-col cols="6" class="pl-2">
                    <v-btn-primary
                        rounded
                        block
                        @click="
                            dialogChooseDownload = false;
                            downloadFile(false);
                        "
                        size="x-large"
                        >Marqué</v-btn-primary
                    >
                </v-col>
            </v-row>
        </template>
    </oss-dialog>

    <!-- ** deleteOrphelinDocumentDialog -->
    <oss-dialog
        v-if="orphelinDepreciationAcrId && orphelinDepreciationAcrId.length"
        v-model="deleteOrphelinDocumentDialog"
        title="Supprimer le contrôle orphelin"
        :error="true"
        @valid="deleteAuditCheckResult(orphelinDepreciationAcrId)"
        :validTitle="'Valider la suppression des amortissements automatiques'"
        :validLoading="deleteOrphelinDocumentLoading"
        width="800px"
    >
        <template v-if="editionMessage && editionMessage.length">
            <div v-html="editionMessage" />
        </template>
    </oss-dialog>

    <!-- ** deleteDocumentDialog -->
    <oss-dialog
        v-model="deleteDocumentDialog"
        title="Supprimer le document"
        :error="true"
        @valid="deleteDocument"
        :validTitle="'Oui je suis sûr(e)'"
        :validLoading="deleteDocumentLoading"
        width="800px"
    >
        <template v-if="editionMessage && editionMessage.length">
            <div v-html="editionMessage" />
        </template>

        <!-- <h4 v-if="editionMessage" class="pb-4">
                Veuillez supprimer le contrôle afin de déverrouiller le document
            </h4> -->
        <!-- <h4 v-else class="pb-4"> -->
        <h4 class="pb-4">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
    </oss-dialog>

    <oss-dialog
        v-model="editDialog"
        title="Editer le document"
        @valid="
            editDocument();
            editDialog = false;
        "
        :validTitle="'Oui je suis sûr(e)'"
        :validLoading="editLoading"
        prefixDataCy="DocumentStatic-editer"
        width="800px"
    >
        <h4 class="text-center">
            &#xca;tes-vous sûr(e) de vouloir éditer le document ? Si vous validez les lettrages
            éventuels seront supprimés
        </h4>
    </oss-dialog>
    <oss-dialog
        v-model="restoreDialog"
        title="Restaurer le document"
        @valid="
            restoreDocument();
            restoreDialog = false;
        "
        :validTitle="'Oui je suis sûr(e)'"
        :validLoading="restoreLoading"
        width="800px"
    >
        <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir restaurer le document ?</h4>
    </oss-dialog>
    <Chat
        v-if="openChat"
        v-bind:id="document.chat ? document.chat.id : ''"
        v-bind:status="'INFORMATION_REQUEST'"
    />
    <oss-dialog
        v-model="dialogUploadDocument"
        title="Importer un document pour ce justificatif"
        max-width="60vw"
        :actions="actions"
    >
        <UploadDocument
            :showFirstPrevious="false"
            :companyId="companyId"
            :documentId="document.id"
            :documentType="'MISCELLANEOUS'"
            :multiple="false"
            :actions="actions"
            :freeTag="false"
            @fileUploaded="
                closeUploadDocumentDialog();
                startToBeDoneIfNecessary();
            "
        />
    </oss-dialog>
    <!-- </v-container> -->
</template>

<script lang="ts">
import moment from "moment-timezone";
import _ from "lodash";

import BUILD_DOCUMENT from "../../graphql/document/BuildDocument.gql";

import Chat from "../chat/Chat.vue";
import { DocumentBase } from "./DocumentBase";
import FreeTag from "../tag/FreeTag.vue";
import AccountableAccountVue from "../AccountableAccount.vue";
import OssPdf from "./DocumentPDF.vue";
import DocumentMenu from "./DocumentMenu.vue";
import AccountingItemStatic from "../AccountingItemStatic.vue";
import UploadDocument from "./UploadDocuments.vue";
import DocumentAuditActions from "./DocumentAuditActions.vue";
import DocumentAdjustments from "./DocumentAdjustments.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import AccountingItemEditionEmbedded from "../AccountingItemEditionEmbedded.vue";
import StockOperationDocumentEdition from "../stock/StockOpDocumentEdition.vue";
import UPDATE_DOCUMENT_EDIT from "../../graphql/document/UpdateDocumentEdit.gql";

import {
    MenuDisplayOptions,
    MenuDisplayDotMenuOptions,
    MenuDisplayZoomOptions,
    MenuDisplayEditOptions,
    MenuDisplayRotationOptions,
    MenuDisplayDisplayModeOptions,
} from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getSiretValue } from "../../../src/services/companyServices";
import {
    adjustmentsPurchasesConditions,
    adjustmentsSalesConditions,
} from "../../services/documentServices";
import { Component, Vue, Watch, Ref, toNative } from "vue-facing-decorator";
import { DialogAction } from "@/services/dialogAction";

@Component({
    components: {
        Chat,
        FreeTag,
        AccountableAccountVue,
        OssPdf,
        AccountingItemStatic,
        UploadDocument,
        DocumentAuditActions,
        DocumentAdjustments,
        UsersActivitiesHistory,
        AccountingItemEditionEmbedded,
        StockOperationDocumentEdition,
        DocumentMenu,
    },
    emits: ["reload", "onEdit"],
})
export class DocumentStatic extends DocumentBase {
    step: number = 0;

    @Ref("accountingLinesEditionEmbedded") accountingLinesEditionEmbedded: any;
    @Ref("ossPdfRef") ossPdf: InstanceType<typeof OssPdf>;
    @Ref("accountingItemStatic") accountingItemStatic: any;

    get documentMenuOptionsZoomButton(): MenuDisplayZoomOptions {
        const zoomButton: MenuDisplayZoomOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.zoomButtons,
        };

        zoomButton.isDisplay =
            (!this.isPDF && this.zoomManager && !this.showAccountingLines) ||
            (this.isPDF && !this.showAccountingLines);
        zoomButton.isZoomInDisabled = this.isPDF ? false : this.zoomManager.disableZoomIn();
        zoomButton.isResetZoomDisabled = this.isPDF ? false : this.zoomManager.disableResetZoom();
        zoomButton.isZoomOutDisabled = this.isPDF ? false : this.zoomManager.disableZoomOut();

        return zoomButton;
    }

    get documentMenuOptionsEditButton(): MenuDisplayEditOptions {
        const editButton: MenuDisplayEditOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.editButton,
        };

        editButton.isDisplay = !!this.showAccountingLines && !!this.displayAIEditionDialog;
        editButton.HTMLMessage = this.editionMessage;
        editButton.disabled = this.disabledAccountingEdition;

        return editButton;
    }

    get documentMenuOptionsDisplayModeButton(): MenuDisplayDisplayModeOptions {
        const displayModeButton: MenuDisplayDisplayModeOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.displayModeButtons,
        };

        displayModeButton.isDisplay =
            (this.isPDF || this.document.signedUrl) &&
            (this.displayAIStaticFull || this.displayActivity);
        displayModeButton.isAccountingLineModeDisplay = this.displayAIStaticFull;
        displayModeButton.isPDFModeDisplay = this.isPDF || this.document.signedUrl;

        return displayModeButton;
    }

    get documentMenuOptionsDotMenu(): MenuDisplayDotMenuOptions {
        let dotMenu: MenuDisplayDotMenuOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
        };

        dotMenu.isDisplay = true;

        dotMenu.download.isDisplay = this.document.signedUrl ? true : false;
        dotMenu.download.title = "Télécharger le document";

        dotMenu.upload.isDisplay = this.document.signedUrl ? false : true;
        dotMenu.upload.title = "Ajouter un document";

        dotMenu.activity.isDisplay = this.isAccountingUser;
        dotMenu.activity.title = "Afficher l'activité";

        dotMenu.delete.isDisplay = true;
        dotMenu.delete.title = "Supprimer";
        dotMenu.delete.HTMLMessage = this.editionMessage;
        dotMenu.delete.disabled = this.disabledDelete;

        return dotMenu;
    }

    get documentMenuOptionsRotateDocumentButton(): MenuDisplayRotationOptions {
        let rotationButton: MenuDisplayRotationOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.RotateDocument,
        };

        rotationButton.isDisplay =
            (!this.isPDF && !this.showAccountingLines) || (this.isPDF && !this.showAccountingLines);

        return rotationButton;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        let documentMenuOption: MenuDisplayOptions = { ...documentMenuDisplayOptionsDefaultScheme };

        documentMenuOption.zoomButtons = this.documentMenuOptionsZoomButton;
        documentMenuOption.editButton = this.documentMenuOptionsEditButton;
        documentMenuOption.RotateDocument = this.documentMenuOptionsRotateDocumentButton;
        documentMenuOption.displayModeButtons = this.documentMenuOptionsDisplayModeButton;
        documentMenuOption.dotMenu = this.documentMenuOptionsDotMenu;

        return documentMenuOption;
    }

    /**
     * Zooms in the PDF by increasing its zoom level.
     */
    public zoomInPdf(): void {
        if (this.ossPdf) {
            this.ossPdf.zoomIn();
        }
    }

    /**
     * Resets the zoom level of the PDF to its default state.
     */
    public resetZoomPdf(): void {
        if (this.ossPdf) {
            this.ossPdf.resetZoom();
        }
    }

    /**
     * Zooms out the PDF by decreasing its zoom level.
     */
    public zoomOutPdf(): void {
        if (this.ossPdf) {
            this.ossPdf.zoomOut();
        }
    }

    actions = {
        action: new DialogAction(),
    };

    get showDocument() {
        return !!this.step;
    }

    set showDocument(value) {
        this.step = value ? 1 : 0;
    }

    get headers() {
        if (this.multiAccountableAccount) {
            return [
                {
                    text: "Compte comptable",
                    value: "accountableAccount",
                    sortable: true,
                    align: "center",
                },
                { text: "HT", value: "netAmount", sortable: false, align: "center" },
                { text: "Taux", value: "vatRate", sortable: false, align: "center" },
                { text: "TVA", value: "vatAmount", sortable: false, align: "center" },
                { text: "TTC", value: "grossAmount", sortable: true, align: "center" },
            ];
        }
        return [
            { text: "HT", value: "netAmount", sortable: false, align: "center" },
            { text: "Taux", value: "vatRate", sortable: false, align: "center" },
            { text: "TVA", value: "vatAmount", sortable: false, align: "center" },
            { text: "TTC", value: "grossAmount", sortable: true, align: "center" },
        ];
    }

    valid = false;

    validated = false;

    loading = false;

    updating = false;

    dialogSelectCompany = false;

    windowStep = 0;

    showAccountingLines = false;

    dialogUploadDocument = false;

    accountingItemEditionEmbeddedFullMode = false;

    tooltipDocumentAdjustmentBtn: String = "";

    accountingLinesLockedDialog = false;

    auditChildren: string = "";
    // auditChildrenName: string = ""
    documentAcrStatus: string = "";
    adjustmentAcKey: string = "";

    // @State2Way("updateFilter", "documentFilter")
    // filter!: any;

    // @State2Way(
    //     "updateShowFilterBox",
    //     state => state.documentFilter.showFilterBox
    // )
    // showFilterBox!: boolean;

    // @State2Way("updatePagination", "documentFilter.pagination")
    // pagination!: any;

    get disabledValidation() {
        // @ts-ignore
        const result =
            this.$refs?.accountingLinesEditionEmbedded?.getDisabledValidation() ||
            this.$refs?.accountingLinesEditionEmbedded?.disabledValidation;
        return result;
    }

    get displayStaticClient() {
        return (
            (!this.isAccountingUser && this.showDetail) ||
            this.inDocument.invoice ||
            !this.displayAccountingItemEditionEmbedded
        );
    }

    get displayAIStaticFull() {
        return this.isAccountingUser;
    }

    get displayAIEditionDialog() {
        if (this.documentIsInAccountingClosing) {
            return false;
        }
        return (
            this.isAccountingUser &&
            ((!this.documentLinked && this.accountingLinesLocked) || this.inDocument.invoice)
        );
    }

    get displayAccountingItemEditionEmbedded() {
        return (
            this.documentLinked &&
            this.isAccountingUser &&
            !this.inDocument?.invoice &&
            !this.documentIsInAccountingClosing &&
            this.accountingLinesLocked
        );
    }

    get documentLinked() {
        return !!this.document.signedUrl;
    }

    newCommonFormatCurrency(value) {
        return newCommonFormatCurrency(value, undefined);
    }

    getAmountClass(price) {
        let amountClass = "d-flex justify-center ";
        amountClass += price.total ? "font-weight-bold" : "font-weight-regular";
        return amountClass;
    }

    buildMetadata(document: any, key: string, valueType = "number") {
        return document[`${key}`];
    }

    @Watch("documentId")
    async onDocumentChanged(prev, next) {
        if (prev !== next) {
            this.document = this.inDocument;
            await this.getAnalysis();
            this.clearVariantList();
            this.computeSVGVariants(this.inDocument);

            if (this.document.signedUrl && !this.isPDF) {
                this.zoomManager.instanciateSvgZoom(this.svgSuffix);
            }
            if (!this.inDocument?.signedUrl && this.isAccountingUser) {
                this.showAccountingLines = true;
            }
            this.dueDate = this.inDocument.dueDate || this.inDocument.date;
            this.finishMounted();
        }
    }

    beforeMount() {
        this.svgSuffix = "document-static";
        // debugger
        // console.log("documentStatic beforeMount");
        this.onDocumentChanged(this.inDocument.id, undefined);
        console.log("document static", this.goBackHistory, this.mode);
    }

    formatOrderBy() {
        const fieldName = this.pagination.sortBy[0] || "type";
        let direction = "";
        if (fieldName !== "updatedAt") {
            direction = this.pagination.descending[0] ? "_DESC" : "_ASC";
        } else {
            direction = this.pagination.descending[0] ? "_ASC" : "_DESC";
        }
        return fieldName + direction;
    }
    //
    // edit
    //

    editDialog = false;
    restoreDialog = false;
    editLoading = false;

    get isFromInvoice() {
        if (this.documentIsInAccountingClosing) {
            return false;
        }
        //
        // document from invoice is editable to let accounting user modify the accounting transaction
        //
        if (this.inDocument.invoice) {
            return true;
        }
    }
    get isEditable() {
        if (this.documentIsInAccountingClosing) {
            return false;
        }
        //
        // document from invoice is editable to let accounting user modify the accounting transaction
        //
        if (this.inDocument.invoice) {
            return false;
        }

        if (!this.inDocument.signedUrl) return false;
        if (this.inDocument.accountingLinesLocked) return false;
        if (this.inDocument.accountingItemImport) return false;

        if (this.inDocument.vatDeclaration) return false;

        if (
            this.inDocument.type !== "PURCHASE_INVOICE" &&
            this.inDocument.type !== "SALES_INVOICE" &&
            this.inDocument.type !== "EXPENSE_REPORT_DOCUMENT" &&
            this.inDocument.type !== "CURRENT_ACCOUNT" &&
            this.inDocument.type !== "OPERATOR_ACCOUNT"
        ) {
            return false;
        }
        return true;
    }

    get isEditableAndFromInvoice() {
        if (this.documentIsInAccountingClosing) {
            return false;
        }
        //
        // document from invoice is editable to let accounting user modify the accounting transaction
        //
        if (this.inDocument.invoice) {
            return false;
        }

        return false;
    }

    //
    // accountable account
    //

    subNetAmountsLoading = false;

    closeMultiAccountableAccountWindow() {
        this.subNetAmountsLoading = true;
        this._closeMultiAccountableAccountWindow();
        this.subNetAmountsLoading = false;
        this.windowStep = 0;
    }

    async onSubAccountableAccountModified() {
        this.subNetAmountsLoading = true;
        await this._onSubAccountableAccountModified();
        this.subNetAmountsLoading = false;
        this.windowStep = 0;
    }

    async build() {
        if (this.document && this.document.id && this.buidIsNeccessary) {
            await this.$apollo.mutate({
                mutation: BUILD_DOCUMENT,
                variables: {
                    id: this.document.id,
                },
            });
            this.$emit("edit", {
                documentId: this.documentId,
            });
        }
    }

    get multiAccountableAccount() {
        if (
            this.document.data &&
            this.document.data.subAmounts &&
            this.document.data.subAmounts.length
        ) {
            let aa;
            for (const subAmountData of this.document.data.subAmounts) {
                if (!subAmountData.accountableAccount) {
                    continue;
                }
                if (!aa) {
                    aa = subAmountData.accountableAccount;
                    continue;
                }
                if (aa !== subAmountData.accountableAccount) {
                    return true;
                }
            }
        }
        return false;
    }

    async validAccountingLines() {
        // @ts-ignore
        if (!this.disabledValidation) {
            await this.$refs.accountingLinesEditionEmbedded.valid();
            // this.$emit('reload')

            if (this.document?.id) {
                await this.$apollo.mutate({
                    mutation: UPDATE_DOCUMENT_EDIT,
                    variables: {
                        id: this.document.id,
                        status: "VALIDATED",
                    },
                });
                this.startToBeDoneIfNecessary();
            }
        } else {
            debugger;
        }
    }

    get rightColumnSize() {
        if (this.displayAccountingItemEditionEmbedded) {
            return 6;
        }
        if (this.isAccountingItem) {
            if (!this.isAccountingUser) return 6;
            // return 4;
        }
        return 5;
    }

    //
    // old version : subNetAmounts or netAmountSigned1 | netAmountSigned2 | netAmountSigned3
    //
    get oldVersion() {
        if (
            this.document.data &&
            this.document.data.subNetAmounts &&
            this.document.data.subNetAmounts.length
        ) {
            return true;
        }
        if (this.document.netAmount1) {
            return true;
        }
        return false;
    }

    get newVersion() {
        return !this.oldVersion;
    }

    get prices() {
        const prices = [];

        const signed = this.document.grossAmountSigned < 0 ? -1 : 1;
        //--------------------------------------
        // DEPRECATED : waiting full migration -
        // retro compatibilité
        //--------------------------------------
        if (this.document.netAmount1) {
            prices.push({
                total: false,
                netAmountSigned: -signed * this.document.netAmount1,
                vatAmountSigned: -signed * this.document.vatAmount1,
                grossAmountSigned: signed * this.document.grossAmount1,
                vatRate: this.document.vatRate1,
            });
        }
        if (this.document.netAmount2) {
            prices.push({
                total: false,
                netAmountSigned: -signed * this.document.netAmount2,
                vatAmountSigned: -signed * this.document.vatAmount2,
                grossAmountSigned: signed * this.document.grossAmount2,
                vatRate: this.document.vatRate2,
            });
        }
        if (this.document.netAmount3) {
            prices.push({
                total: false,
                netAmountSigned: -signed * this.document.netAmount3,
                vatAmountSigned: -signed * this.document.vatAmount3,
                grossAmountSigned: signed * this.document.grossAmount3,
                vatRate: this.document.vatRate3,
            });
        }
        //--------------
        // NEW VERSION -
        //--------------
        if (this.document.data && this.document.data.subAmounts) {
            // debugger
            for (const subAmountData of this.document.data.subAmounts) {
                const grossAmountSigned =
                    subAmountData.grossAmountSigned ||
                    -(subAmountData.netAmountSigned + subAmountData.vatAmountSigned);
                prices.push({
                    total: false,
                    netAmountSigned: subAmountData.netAmountSigned,
                    vatAmountSigned: subAmountData.vatAmountSigned,
                    grossAmountSigned: grossAmountSigned,
                    vatRate: subAmountData.vatRate,
                    vatType: subAmountData.vatType,
                    accountableAccount: subAmountData.accountableAccount
                        ? subAmountData.accountableAccount
                        : undefined,
                });
            }
        }
        for (const price of prices) {
            if (price.vatRate === 0) {
                price.vatType = this.document.vatType;
            }
        }
        //--------
        // TOTAL -
        //--------
        prices.push({
            total: true,
            vatAmountSigned: this.document.vatAmountSigned,
            netAmountSigned: this.document.netAmountSigned,
            grossAmountSigned: this.document.grossAmountSigned,
            vatRate: this.document.vatRate,
            vatTye: this.document.vatType,
        });

        return prices;
    }

    setWindowStep() {
        this.windowStep = 0;
    }

    openWindowStep10(data) {
        this.auditChildren = data.auditChildren;
        this.documentAcrStatus = data.documentAcrStatus;
        this.adjustmentAcKey = data.adjustmentAcKey;
        this.windowStep = data.value;
    }

    // ** fixedAssets are not opened in window
    // ** they will be routed in DocumentAuditActions with openFixedAssets()
    // openWindowStep20(data) {
    //     debugger
    //     this.auditChildren = data.auditChildren
    //     this.documentAcrStatus = data.documentAcrStatus
    //     this.adjustmentAcKey = data.acKey
    //     this.windowStep = data.value
    // }

    get showAudit() {
        if (this.isAccountingUser) {
            if (this.document?.status === "VALIDATED") {
                return true;
            }
        }
        return false;
    }

    // get documentAcrStatus() {
    //     if (this.document && this.document.auditCheckResults && this.document.auditCheckResults.length) {
    //         let acr

    //         if (this.acKey.length) {
    //             acr = this.document.auditCheckResults.find(acr => (acr as any).auditCheck.key === this.acKey)
    //         }

    //         if (acr && Object.keys(acr).length) {
    //             return acr.status
    //         }
    //     }
    //     return ""
    // }

    get having6or7AccountableAccounts() {
        if (
            this.document &&
            this.document.accountingLines &&
            this.document.accountingLines.length
        ) {
            const having6or7AA = this.document.accountingLines.find(
                (al) => adjustmentsPurchasesConditions(al) || adjustmentsSalesConditions(al),
            );
            if (having6or7AA) {
                return true;
            }
            return false;
        }
        // ** no accountingLines ?
        return false;
    }

    openAccountingItemEditionDialog() {
        if (this.$refs?.accountingItemStatic?.openEditDialog) {
            this.$refs.accountingItemStatic.openEditDialog();
        } else {
            console.error("openAccountingItemEditionDialog accountingItemStatic undefined");
        }
    }

    closeUploadDocumentDialog() {
        this.dialogUploadDocument = false;
        this.$emit("onEdit");
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    // get showFixedAssets() {
    //     const havingFixedAssets = this.document.accountingLines
    //         .find(al => al.accountableAccount.name.startsWith("20") ||
    //         al.accountableAccount.name.startsWith("21") ||
    //         al.accountableAccount.name.startsWith("22") ||
    //         al.accountableAccount.name.startsWith("23")
    //     )
    //     if (havingFixedAssets) {
    //         return true
    //     }
    //     return false
    // }
}

export default toNative(DocumentStatic);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
